import { Switch } from '@headlessui/react';

interface ToogleButtonParams {
  enabled: boolean;
  toogleAction: (enabled: boolean) => void;
  label: string;
}

const ToogleButton = ({ enabled, toogleAction, label }: ToogleButtonParams) => {
  return (
    <div className="flex flex-row">
      <Switch
        checked={enabled}
        onChange={toogleAction}
        className={`${
          enabled ? 'bg-ph-purple' : 'bg-ph-gray-dirty-white'
        } relative mr-3 inline-flex h-5 w-9 items-center rounded-full`}
      >
        <span className="sr-only">{label}</span>
        <span
          className={`${
            enabled ? 'translate-x-4' : 'translate-x-1'
          } inline-block h-4 w-4 transform rounded-full bg-white transition`}
        />
      </Switch>

      <label className="text-left text-sm font-bold leading-5 text-white">{label}</label>
    </div>
  );
};

export default ToogleButton;
